import React, { useEffect } from 'react';
import { initMetaPixel } from '../utils/metaPixel';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { ProblemSection } from '../components/ProblemSection';
import { JarSystemSection } from '../components/JarSystemSection';
import { SleepCascadeSection } from '../components/SleepCascadeSection';
import { PricingSection } from '../components/PricingSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen w-full overflow-hidden selection:bg-gold selection:text-warm-900" data-id="element-204">
      <HeroSection data-id="element-205" />
      <PainSection data-id="element-206" />
      <ProblemSection data-id="element-207" />
      <JarSystemSection data-id="element-208" />
      <SleepCascadeSection data-id="element-209" />
      <PricingSection data-id="element-210" />
      <FinalCTA data-id="element-211" />
      <Footer data-id="element-212" />
    </main>;
}